import {
    GETUPDATECONFIGURATIONADMIN_SUCCESS,
    GETUPDATECONFIGURATIONADMIN_FAILED,
    RESET_GETUPDATECONFIGURATIONADMIN,
    LOADING_GETUPDATECONFIGURATIONADMIN,
    NETWORK_ERROR_GETUPDATECONFIGURATIONADMIN
} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETUPDATECONFIGURATIONADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETUPDATECONFIGURATIONADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETUPDATECONFIGURATIONADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETUPDATECONFIGURATIONADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETUPDATECONFIGURATIONADMIN:
            return (state = initialState);
        default:
            return state;
    }
};